import React from 'react';
import firebase from 'firebase';

class FilterLocation extends React.Component {
  state = {
    isLoading: true,
    locations: [],
  }

  async componentDidMount() {
    const locations = [];

    const getLocationsFromFirebase = await firebase.database().ref('/locations').once('value');
    getLocationsFromFirebase.forEach(location => {
      locations.push({
        locationId: location.key,
        address: location.val().address,
      });

      this.setState({ isLoading: false, locations });
    });
  }

  render() {
    const { isLoading, locations } = this.state;
    const { onChange } = this.props;

    if (isLoading) {
      return <div />;
    }

    return (
      <div className="form-group">
        <label>Select a Location</label>
        <select onChange={onChange} className="form-control">
          <option />
          {locations.map(({ locationId, address }) => (
            <option key={locationId} value={locationId}>{address}</option>
          ))}
        </select>
      </div>
    );
  }
}

export default FilterLocation;
